import settings from '@/config/settings';

import type {TAPIElementFieldNames} from '@/assets/core/assets/api/types';
import type {IUser, IUserMapConfig} from '@/api/types/user';
import {EApiRequestMethod} from '@/assets/core/assets/api/enums';

import {userAPI} from '@/api/requesters/user';

import doRequest from '@/assets/core/assets/api/doRequest';

const fieldNames: TAPIElementFieldNames<IUser> = {
  pageTitle: 'Пользователи',
  drawerTitle: 'Пользователь',

  id: 'Ид.',
  name: 'Имя',
  username: 'Имя',
  email: 'e-mail',

  roles: 'Роли',
  tech_roles: 'Роли (технические)',
  view_roles: 'Роли (видимости)',
  view_roles_map: 'Роли (видимости)',
  map_config: 'Конфигурация карты',
};

const mapConfigFieldNames = {
  latitude: 'Широта',
  longitude: 'Долгота',
  zoom: 'Масштаб',
};

const useUserControllerHook = () => {
  const api = userAPI.clone();

  const getOneMe = async () => await api.getOne('me');

  const updateOneMeMapConfig = async (data: IUserMapConfig) => {
    return doRequest(
      new URL(settings.SERVICES.BACK.getUrl() + '/users/me/map-config'),
      EApiRequestMethod.PATCH,
      data,
    );
  };

  const validate = () => true;

  return {
    ...api,
    fieldNames,
    mapConfigFieldNames,

    validate,
    getOneMe,
    saveMapConfig: updateOneMeMapConfig,
  };
};

const userController = useUserControllerHook();

export default userController;
